import { render, staticRenderFns } from "./EMChecklist.vue?vue&type=template&id=39804e46&scoped=true&"
import script from "./EMChecklist.vue?vue&type=script&lang=js&"
export * from "./EMChecklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39804e46",
  null
  
)

export default component.exports